/**
 * @private
 */
// Export constants for direct import
export var RIBBON_ID = '_ribbon';
